import axios from 'axios';

import {
  AddPropertyShowingAgentDto,
  TeamShowingAgentsDto,
  TeamSubject,
} from '../interfaces/property-showing-agent.dto';
import { SaveShowingAgentDto } from '../interfaces/save-showing-agent.dto';
import { ShowingAgentDto } from '../interfaces/showing-agent.dto';
import { UpdateShowingAgentDto } from '../interfaces/update-showing-agent.dto';

/** The company roster, and a unit's own list, or with `building` a building's, whose routes mirror a unit's */
class ShowingAgentsService {
  constructor(private readonly kind: TeamSubject['kind'] = 'property') {}

  async getList() {
    const response = await axios.get<ShowingAgentDto[]>('showing-agents');

    return response.data;
  }

  async create(payload: SaveShowingAgentDto) {
    const response = await axios.post<ShowingAgentDto>('showing-agents', payload);

    return response.data;
  }

  async update(showingAgentId: string, payload: UpdateShowingAgentDto): Promise<void> {
    await axios.patch(`showing-agents/${showingAgentId}`, payload);
  }

  async getForProperty(id: string): Promise<TeamShowingAgentsDto> {
    return (await axios.get<TeamShowingAgentsDto>(`${this.kind}/${id}/showing-agents`)).data;
  }

  async addToProperty(id: string, payload: AddPropertyShowingAgentDto): Promise<TeamShowingAgentsDto> {
    return (await axios.post<TeamShowingAgentsDto>(`${this.kind}/${id}/showing-agents`, payload)).data;
  }

  /** Off this list only; the roster entry, their showings and their place on other units and buildings stay */
  async removeFromProperty(id: string, showingAgentId: string): Promise<TeamShowingAgentsDto> {
    return (await axios.delete<TeamShowingAgentsDto>(`${this.kind}/${id}/showing-agents/${showingAgentId}`)).data;
  }
}

const showingAgentsService = new ShowingAgentsService();
const buildingShowingAgentsService = new ShowingAgentsService('building');

export function showingAgentsServiceFor(subject: TeamSubject): ShowingAgentsService {
  return subject.kind === 'building' ? buildingShowingAgentsService : showingAgentsService;
}

export default showingAgentsService;
